import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import { api } from '../../reducers';
import Login from '../../components/auth/Login';

function mapStateToProps(state) {
  return {
    authentication: state.api.authentication
  };
}

function mapDispatchToProps(dispatch) {
  let requestLogin = api.requestLogin;
  let checkLogin = api.checkLogin;
  return bindActionCreators({ requestLogin, checkLogin }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));